import { render } from "./ListCompanies.vue?vue&type=template&id=2cace9fc"
import script from "./ListCompanies.vue?vue&type=script&lang=js"
export * from "./ListCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__